var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{attrs:{"options":_vm.address.options,"props":_vm.address.props},on:{"active-item-change":_vm.handleItemChange,"change":_vm.handleChange},model:{value:(_vm.areainfo),callback:function ($$v) {_vm.areainfo=$$v},expression:"areainfo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }